module.exports = __webpack_public_path__ + "img/image-1.d9c45b9f.jpg";